import {AbstractControl, FormGroup, NG_VALIDATORS, Validator, ValidatorFn} from "@angular/forms";
import {Directive} from "@angular/core";
import {isNullOrUndefined} from 'util';

export function revenueSharesValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        let formGroup = <FormGroup>control;
        let shareInputAliases = Object.keys(formGroup.controls).filter(alias => {
            return alias.startsWith('editShare');
        });
        let shareSelectAliases = Object.keys(formGroup.controls).filter(alias => {
            return alias.startsWith('editSystemShare');
        });
        if(shareInputAliases.length == 0 && shareSelectAliases.length == 0) {
            return null;
        }
        let total = 0;
        shareInputAliases.forEach(alias => {
            total += Math.abs(parseFloat(formGroup.controls[alias].value));
        });
        shareSelectAliases.forEach(alias => {
            let value = formGroup.controls[alias].value;
            if (!isNullOrUndefined(value) && !isNullOrUndefined(value.percent)) {
                total += value.percent;
            }
        });
        if(total == 100.0) {
            return null;
        }
        return {
            totalSharesPercentage: total,
        };
    }
}

@Directive({
    selector: '[ngModelGroup][tflValidShares]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: SharesValidatorDirective,
        multi: true
    }]
})
export class SharesValidatorDirective implements Validator {
    validate(control: AbstractControl): { [key: string]: any } {
        return revenueSharesValidator()(control);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/rules/shares-validator.directive.ts